export default ({ route, store, redirect }) => {
  if(store.state.auth.loggedIn) {
    const redirectPath = store.getters.redirectPath
    if(redirectPath) {
      store.commit('setRedirectPath', false)
      return redirect(redirectPath)
    }
  }
  else {
    store.commit('setRedirectPath', route.fullPath)
  }
}